module.exports = __webpack_public_path__ + "static/adamson-4e8dc5c767e00628beff47ea81f269ea.png";